// 顶部导入保留部分 + 修正点（移除 process.config，增加 InitChatStoreConfig）
import {
    InitFriendStoreConfig,
    useFriendStore as useFriendStoreHook,
    useChatStore as useChatStoreHook,
    useChannelRoomStore as useChannelRoomStoreHook,
    useGlobalStore,
    // 新增：为 ChatStore 引入它的初始化类型
    InitChatStoreConfig,
} from "@obsbot/remo-stores";
import { useSafePromise } from "remo-components";
import { useEffect } from "react";
import { RemoServices } from "@obsbot/remo-services";
import { useNavigate } from "react-router-dom";
import { eventBus } from "@obsbot/remo-utils";
import { useTranslate } from "@obsbot/remo-i18n";
import { logout } from "@obsbot/remo-server-api";

export type useRTMConfig = Omit<InitFriendStoreConfig, "rtm">;
// 修正：函数签名语法错误，改为标准形式（本 Hook 不需要返回值）
export const useRTMStore = (config: useRTMConfig): void => {
    // const { userUUID = "Michael" } = useUserStore();
    const { rtcInfo, userInfo } = useGlobalStore();
    const friendStore = useFriendStoreHook();
    const chatStore = useChatStoreHook();
    const sp = useSafePromise();
    const navigate = useNavigate();
    const t = useTranslate();

    useEffect(() => {
        // 判断用户是否登录，有用户的登录信息
        if (!rtcInfo || !userInfo) {
            return;
        }
        let isUnmounted = false;

        const remoServices = RemoServices.getInstance();

        console.log("[DEBUG LOG] 请求service use-rtm-store 请求textChat");
        sp(Promise.all([remoServices.requestService("textChat")]))
            .then(async ([textChat]) => {
                if (!isUnmounted && textChat) {
                    // 关键：等待 init 完成，让错误能冒泡到外层 catch
                    await textChat.init({
                        uid: rtcInfo.uid,
                        userSig: rtcInfo.userSig,
                    });
                    // 为两个 Store 分别使用各自的初始化类型
                    const chatInitConfig: InitChatStoreConfig = { rtm: textChat };
                    const friendInitConfig: InitFriendStoreConfig = { rtm: textChat };
                    useChatStoreHook.getState()?.initStore(chatInitConfig);
                    useFriendStoreHook.getState()?.initStore(friendInitConfig);
                    useChannelRoomStoreHook.setState({ rtm: textChat });
                }
            })
            .catch(err => {
                console.error("初始化RTM失败:", err);
                // 如果是web端直接退出登录后刷新界面，如果是PC端，提示用户关闭软件后重新打开
                eventBus.emit("show-message", {
                    message: t("init_rtm_failed_" + process.env.REMO_CLIENT_TYPE),
                    type: "error",
                });
                localStorage.clear();
                if (process.env.REMO_CLIENT_TYPE === "web") {
                    logout();
                    navigate("/login");
                    window.location.reload();
                }
            });
        return () => {
            isUnmounted = true;
            friendStore?.destroy();
            chatStore?.destroy();
            remoServices.shutdownService("textChat");
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [config, rtcInfo, userInfo]);

    // 本 Hook 不返回值，移除 return
};
